var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 24C12.5 23.1716 13.1716 22.5 14 22.5H34C34.8284 22.5 35.5 23.1716 35.5 24C35.5 24.8284 34.8284 25.5 34 25.5H14C13.1716 25.5 12.5 24.8284 12.5 24Z",
    fill: "#56AF31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 16C12.5 15.1716 13.1716 14.5 14 14.5H26C26.8284 14.5 27.5 15.1716 27.5 16C27.5 16.8284 26.8284 17.5 26 17.5H14C13.1716 17.5 12.5 16.8284 12.5 16Z",
    fill: "#56AF31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.5C8.61929 7.5 7.5 8.61929 7.5 10V39.7237L11.6277 34.5642C12.6714 33.2596 14.2516 32.5 15.9225 32.5H38C39.3808 32.5 40.5 31.3808 40.5 30V10C40.5 8.61927 39.3808 7.5 38 7.5H10ZM6.96574 40.3916C6.96568 40.3916 6.9658 40.3915 6.96574 40.3916V40.3916ZM4.5 10C4.5 6.96243 6.96243 4.5 10 4.5H38C41.0376 4.5 43.5 6.96245 43.5 10V30C43.5 33.0376 41.0376 35.5 38 35.5H15.9225C15.1631 35.5 14.4448 35.8452 13.9703 36.4383C13.9703 36.4383 13.9703 36.4382 13.9703 36.4383L9.30836 42.2656C7.71404 44.2586 4.5 43.1314 4.5 40.579V10Z",
    fill: "#56AF31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.c2a8dc63e543b4b4e6348f9efd5f62ff.svg";
export { ForwardRef as ReactComponent };